import { render, staticRenderFns } from "./TheMenuSelect.vue?vue&type=template&id=da6145a6&"
import script from "./TheMenuSelect.vue?vue&type=script&lang=js&"
export * from "./TheMenuSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheMenuSelect.vue"
export default component.exports